import { PatientAttachment } from '../../AttachmentArbiter/Attachment';
import { createRenderingTracker, trackingKey } from '../createRenderingTracker';

/**
 * Why a tracker for patient attachments?
 * Patient citations don't currently produce inline widgets in the report
 * (they fall through the unsupported-attachment logging path). The tracker
 * is kept here for symmetry: if a patient-card widget is added later, dedup
 * is already wired up and a citation that names the same patient twice
 * won't render two cards. Identity is the FHIR `ResourceType/id`.
 */
export type PatientTrackerInput = {
  attachment: PatientAttachment;
};

const handle = createRenderingTracker<PatientTrackerInput>(({ attachment }) =>
  trackingKey(attachment.identifier),
);

export const PatientTrackingProvider = handle.Provider;
export const usePatientTracker = handle.useTracker;
